import React, {ReactNode} from "react";
import {LogoutDialogDefinition} from "../../../shared/dialog/components/LogoutDialog";
import {AbstractDialogProperties} from "../../../shared/dialog/components/AbstractDialog";
import {Dialog} from "primereact/dialog";
import Translate from "../../../shared/translation/Translate";
import {InputSwitch} from "primereact/inputswitch";
import LogoutDialogFields from "../../../shared/dialog/fields/LogoutDialogFields";
import MessageBox from "../../../shared/components/MessageBox";
import {MessageType} from "../../../shared/log/MessageInterface";
import {Button} from "primereact/button";
import portalConfiguration from "../../../shared/configuration/PortalConfiguration";
import Portal from "../../../portal/Portal";
import Admin from "../../Admin";
import {AuthProvider} from "@softvision/webpdf-wsclient-9-typescript/lib/generated-sources";
import FunctionHelper from "../../../shared/helper/FunctionHelper";

export class AdminLogoutDialogDefinition extends LogoutDialogDefinition {
	public renderDialog(): ReactNode {
		let provider: AuthProvider | undefined = this.getProvider();

		let classList: Array<string> = ["logout-dialog"];
		if (this.state.submitted) {
			classList.push("submitted");
		}

		return (
			<Dialog className={classList.join(" ")} visible={this.props.visible} onHide={this.hide}
					closeOnEscape={false} header={this.renderHeader()} footer={this.renderFooter()} resizable={false}
					appendTo={document.getElementById("root")}>
				<div className="p-grid">
					{this.renderError()}
					<fieldset className="p-col-12 p-grid">
						<MessageBox {...this.props} type={MessageType.DANGER}>
							<Translate {...this.props} data="logout.admin" namespace="dialog"/>
						</MessageBox>
					</fieldset>
					<fieldset className="p-col-12 p-grid">
						<div className="dialog-message">
							<Translate {...this.props} data="logout.message" namespace="dialog"/>
						</div>
					</fieldset>
					{FunctionHelper.exists(provider?.logout?.url) &&
						<fieldset className="p-col-12 p-grid">
							<label className="p-col-1"/>
							<div className="p-col-11 switch-container">
								<InputSwitch checked={this.state.logoutProvider} inputId="control-provider"
											 onChange={(e) => this.onChange(
												 LogoutDialogFields.PROVIDER, e.value
											 )}/>
								<label className="switch-label" htmlFor="control-provider">
									<Translate {...this.props} data="logout.provider" namespace="dialog"/>
								</label>
							</div>
						</fieldset>
					}
				</div>
			</Dialog>
		);
	}

	protected renderHeader(): ReactNode {
		return (
			<div>
				<h1>
					{this.renderHeaderIcon()}
					<Translate {...this.props} data="logout.title" namespace="dialog"/>
				</h1>
			</div>
		);
	}

	/**
	 * Render the dialog footer
	 */
	protected renderFooter(): ReactNode {
		return (
			<div>
				<Button label={Translate.value("buttons.logout")} className="primary-button"
						icon={"icon" + (this.state.submitted ? " icon-spinner spin" : " icon-logout")}
						onClick={() => this.submit()}/>
				<Button label={Translate.value("buttons.back_to_portal")} icon="icon icon-home"
						className="dialog-button" style={{marginLeft: "20px"}}
						onClick={() => {
							window.location.href = portalConfiguration.baseUrl.toString() + Portal.route;
						}}/>
			</div>
		);
	}

	protected replaceVariables(value: string, provider: AuthProvider): string {
		switch (value) {
			case "{redirectUrl}":
				return portalConfiguration.portalUrl.toString() + Admin.route;
			case "{clientId}":
				return provider.clientId!;
		}

		return value;
	}
}

const AdminLogoutDialog = React.memo(AdminLogoutDialogDefinition,
	(prevProps: Readonly<AbstractDialogProperties>, nextProps: Readonly<AbstractDialogProperties>) => {
		if (!nextProps.visible && !prevProps.visible) {
			return true
		}

		return false;
	}
);

export default AdminLogoutDialog;